import { useState } from "react";
import SectionHead from "./SectionHead";
import { RANK_LIST, RANK_TABS, SIDE_TOPICS } from "../../../mocks/chigua";

const trendIcon: Record<string, { icon: string; cls: string; label: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600", label: "上升" },
  new: { icon: "ri-sparkling-2-fill", cls: "text-accent-600", label: "新进" },
  hot: { icon: "ri-fire-fill", cls: "text-primary-600", label: "爆" },
  steady: { icon: "ri-check-line", cls: "text-foreground-400", label: "稳" },
};

export default function HotRank() {
  const [tab, setTab] = useState(0);

  const list = [...RANK_LIST].slice(tab).concat([...RANK_LIST].slice(0, tab));

  return (
    <section id="rank" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <SectionHead
          no="02"
          kicker="Trending · 网友热议"
          title="抓奸实录网友热议榜"
          sub="按评论区实时热度滚动排序：越多人蹲、越多人吵、越多人补刀，位次就越高。标题都是短摘要体，扫一眼就能接入讨论广场。"
          right="看完整榜单"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          {/* 榜单 */}
          <div className="lg:col-span-8">
            {/* segmented tab */}
            <div className="inline-flex items-center rounded-full border border-background-300/80 bg-background-50 p-1 mb-5">
              {RANK_TABS.map((t, i) => (
                <button
                  key={t}
                  onClick={() => setTab(i)}
                  className={
                    "px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap " +
                    (tab === i
                      ? "bg-primary-600 text-background-50 font-medium"
                      : "text-foreground-600 hover:text-primary-700")
                  }
                >
                  {t}
                </button>
              ))}
            </div>

            <div className="divide-y divide-background-200/80 rounded-lg border border-background-200/80 bg-background-50 overflow-hidden">
              {list.map((r, i) => {
                const rank = i + 1;
                const meta = trendIcon[r.trend];
                return (
                  <div key={r.id} className="group flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 hover:bg-background-100/70 transition-colors">
                    <span
                      className={
                        "shrink-0 font-heading text-xl md:text-3xl font-black w-8 md:w-10 text-center leading-none " +
                        (rank <= 3 ? "text-primary-600" : "text-foreground-300")
                      }
                    >
                      {String(rank).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="text-[15px] md:text-base font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                          {r.title}
                        </h3>
                        <span className="inline-flex items-center gap-1 text-[11px] rounded-sm bg-accent-100 px-1.5 py-0.5 text-accent-800 whitespace-nowrap">
                          {r.tag}
                        </span>
                      </div>
                      <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-1 md:line-clamp-none">{r.summary}</p>
                    </div>
                    <div className="hidden md:flex flex-col items-end gap-1 w-16 shrink-0">
                      <div className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                        <i className="ri-chat-3-line" /> {r.comments}
                      </div>
                      <div className="h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
                        <div className="h-full rounded-full bg-primary-500" style={{ width: `${r.heat}%` }} />
                      </div>
                    </div>
                    <span className="shrink-0 w-9 flex justify-center">
                      <span title={meta.label} className={"inline-flex items-center text-base " + meta.cls}>
                        <i className={meta.icon} />
                      </span>
                    </span>
                  </div>
                );
              })}
            </div>
            <p className="mt-3 text-xs text-foreground-500">共 286 条 · 按今日评论增量实时排序（演示版为静态示意）</p>
          </div>

          {/* 右侧护栏 */}
          <div className="lg:col-span-4 flex flex-col gap-4">
            <div className="rounded-lg border border-background-200/80 bg-foreground-950 p-5 text-background-100 relative overflow-hidden">
              <span className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-primary-600/30" />
              <span className="inline-flex items-center gap-2 text-xs text-accent-400">
                <i className="ri-community-line" /> 今日讨论广场
              </span>
              <div className="mt-4 flex items-end gap-4">
                <span className="font-heading text-4xl font-black text-background-50 leading-none">32.7万</span>
                <span className="text-xs text-background-100/70 mb-1">条热评滚动中</span>
              </div>
              <p className="mt-3 text-xs text-background-100/70 leading-relaxed">
                峰值出现在 22:00–23:30，围观群众最活跃的时段，神评论大多在这个窗口诞生。
              </p>
              <button className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 hover:bg-accent-400 text-foreground-950 px-4 py-2.5 text-sm font-medium transition-colors whitespace-nowrap">
                <i className="ri-flashlight-fill" /> 蹲实时热评
              </button>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <div className="flex items-center justify-between mb-4">
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <i className="ri-price-tag-3-line text-primary-600" /> 吃瓜现场热词
                </span>
                <a href="#quote" className="text-xs text-foreground-500 hover:text-primary-700">刷新</a>
              </div>
              <div className="space-y-2">
                {SIDE_TOPICS.map((t) => (
                  <a
                    key={t.name}
                    href="#scene"
                    className="flex items-center justify-between rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 hover:text-primary-700 transition-colors"
                  >
                    <span className="inline-flex items-center gap-2 truncate">
                      <i className="ri-hashtag text-primary-600" /> {t.name}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">围观 {t.hot}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}